export default __webpack_public_path__ + "static/swapr-4e3fbbda551834ae5cd684ee4b051af2.jpg";